/**
 * 文档下载
 */
<template>
  <div style="margin-top: 20px;">
      <!-- 左边导航 -->
      <div style="margin-bottom: 12px;font-weight: 700;float: left;display: flex;line-height: 40px;height: 40px;">
        <div v-if="docTempAuth" class="mouse" :class="{'selected':docPatentAuthCh}" @click="clickLabel('patent')">专利文档</div>
      
        <div v-if="docTempAuth" class="mouse" :class="{'selected':docMarkAuthCh}" @click="clickLabel('mark')">商标文档</div>
     
        <div v-if="docTempAuth" class="mouse" :class="{'selected':docSoftAuthCh}" @click="clickLabel('soft')">版权文档</div>
    
        <div v-if="docTempAuth" class="mouse" :class="{'selected':docRuleAuthCh}" @click="clickLabel('rule')">商务规则</div>
       
        <div v-if="docTempAuth" class="mouse" :class="{'selected':docOtherAuthCh}" @click="clickLabel('other')">其他文档</div>
       
        <!-- <div style="margin-left: 10px;margin-right: 10px;color: #D9D9D9;">|</div>
        <div v-if="docManageAuth" class="mouse" :class="{'selected':docManageAuthCh}" @click="clickLabel('docManage')">文档管理</div> -->
      </div> 
      <!-- 右侧按钮 -->
      <div style="float: right;display: flex;">
        <el-button size="small" icon="el-icon-refresh" class="clue-btn" @click="refreshData">刷新</el-button>
        <el-button v-if="importDocAuth" size="small" icon="el-icon-plus" class="clue-btn" @click="handleEdit">文档上传</el-button>
        <el-button v-if="deleteDocAuth" size="small" icon="el-icon-delete" class="clue-btn" @click="delDocCheck">删除</el-button>
        <!-- <el-button size="small" icon="el-icon-bottom" class="clue-btn" @click="checkDownLoad">表格下载</el-button>
        <el-button size="small" icon="el-icon-top" class="clue-btn" @click="handleImport">表格上传</el-button> -->
      </div>
    <!-- 列表数据 -->
    <el-table size="small" :data="docData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark" ref="multipleTable" @selection-change="handleSelectionChange">
        <el-table-column align="center" type="selection" width="40">
        </el-table-column>
        <el-table-column align="center" type="index" label="序号" width="60">
        </el-table-column>
        <el-table-column prop="doc_name" align="center" label="文档名称" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="doc_type" align="center" label="文档类型" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="doc_category" align="center" label="所属分类" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="doc_business" align="center" label="所属公司" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="admin_name" align="center" label="操作人" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="load_num" align="center" label="下载次数" width="80" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="doc_desc" align="center" label="备注" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="add_time" align="center" label="添加时间" show-overflow-tooltip>
        </el-table-column>
        <el-table-column align="center" label="操作" width="240" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="previewDoc(scope.index, scope.row)">预览</el-button>
            <el-button size="mini" type="primary" @click="loadDoc(scope.index, scope.row)">下载</el-button>
            <el-button v-if="editDocAuth" size="mini" type="primary" @click="handleEdit(scope.index, scope.row)">编辑</el-button>
            <!-- <el-button size="mini" type="danger" :disabled="scope.row.able" @click="delDoc(scope.index, scope.row)">删除</el-button> -->
          </template>
        </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  
    <!-- 文档编辑 -->
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="docFormVisible" width="600px" @click="closeDialog('docForm')">
      <el-form label-width="120px" :model="docForm" :rules="docFormRule" ref="docForm">

        <el-form-item label="文档名称" prop="doc_name"> 
          <el-input size="small" v-model="docForm.doc_name" auto-complete="off" clearable placeholder="请输入文档名称" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="文档分类" prop="doc_category">
          <el-select size="small" v-model="docForm.doc_category" placeholder="请选择" style="width: 300px;">
            <el-option v-for="type in categroyArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属公司" prop="doc_business">
          <el-select size="small" v-model="docForm.doc_business" placeholder="请选择" style="width: 300px;">
            <el-option v-for="type in businessArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
          
        <el-form-item label="文档备注" prop="doc_desc"> 
          <el-input size="small" v-model="docForm.doc_desc" auto-complete="off" clearable placeholder="请输入文档备注" style="width: 300px;"></el-input>
        </el-form-item>
        <el-form-item label="文档上传"> 
          <el-upload 
            :action=uploadExcel
            :headers=setHeader
            :before-upload="beforeAvatarVideoUpload"
            :on-success="handleSuccess">
            <el-button size="small">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="文档地址" prop="doc_url"> 
          <el-input size="small" v-model="docForm.doc_url" auto-complete="off" disabled style="width: 300px;"></el-input>
        </el-form-item>

        <el-form-item>
            <el-button size="mini" type="primary" @click="editDoc('docForm')">确认</el-button>
            <el-button size="mini" @click="closeDialog('docForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 项目导入 -->
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="importFormVisible" width="50%" @click="closeDialog('importForm')">
        <el-form label-width="120px">
          <el-row>
            <el-form-item label="上传Excel" prop="content">
                <el-upload
                  class="upload-demo"
                  drag
                  :action=uploadExcel
                  :headers=setHeader
                  :before-upload="beforeAvatarVideoUpload"
                  :before-remove="beforeRemove"
                  :on-success="handleSuccess"
                  >
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx或xls文件，且不超过10M
                    <span style="margin-left: 15px;color: #551A8B;cursor: pointer;" title="下载项目导入excel模板" @click="downloadImportExcel()">下载项目模板</span>
                  </div>
                </el-upload>
                </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>

    <div class="rightDrawer" @click="handleDrawerOpen">
      《《
    </div>
    <el-drawer 
    :visible.sync="drawer" 
    :direction="direction" 
    :before-close="handleDrawerClose" 
    size="320px" 
    title="条件查询" 
    :show-close="false"
    :wrapperClosable="true"
    class="searchDrawer" 
    >
      <div style="margin-left: 20px;">
        <el-form :inline="true" :model="formInline">
          <el-form-item label="模糊搜索">
            <el-input size="small" v-model="formInline.search" placeholder="请输入查询值" clearable></el-input>
          </el-form-item>
          <el-form-item label="文档名称">
            <el-input size="small" v-model="formInline.name" placeholder="请输入文档名称" clearable></el-input>
          </el-form-item>
          <!-- <el-form-item label="文档分类">
            <el-input size="small" v-model="formInline.cate" placeholder="请输入文档分类" clearable></el-input>
          </el-form-item>
          <el-form-item label="所属公司">
            <el-input size="small" v-model="formInline.business" placeholder="请输入公司名称" clearable></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="文档分类">
            <el-select size="small" v-model="formInline.cate" placeholder="请选择" filterable clearable>
              <el-option v-for="type in categroyArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="所属公司">
            <el-select size="small" v-model="formInline.business" placeholder="请选择" filterable clearable>
              <el-option v-for="type in businessArr" :label="type.key" :value="type.value" :key="type.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="searchDoc">查询</el-button>
            <el-button type="warning" size="small" @click="resetSearch">重置</el-button>
            <el-button type="danger" size="small" @click="handleDrawerClose">关闭</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-drawer>

    <!-- 文档预览PDF -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :title="title" :visible.sync="viewPDFVisible" width="850px" height="400px">
      <iframe :src="viewPDFUrl" style="width: 800px;height: 600px;"></iframe>
    </el-dialog>

  </div>
</template>

<script>
import { getProject, 
  editProject, 
  delProject, 
  downloadProject, 
  webUrl, 
  getImportProjectExcel,
  getDocList, 
  loadDoc, 
  editDoc, 
  delDoc,
  delCheckDoc,
  getDictCate } from '../../api/crmMG'
import Pagination from '../../components/Pagination'
import '../../assets/js/directive'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      loading: false, //是显示加载
      projectFormVisible: false, //控制编辑页面显示与隐藏
      importFormVisible: false, //控制导入界面显示与隐藏
      docFormVisible: false, //控制文档编辑页面显示与隐藏
      viewFormVisible: false, //控制文档预览页面显示与隐藏
      viewPDFVisible: false, //控制PDF文档预览页面显示与隐藏

      viewPDFUrl: '', //pdf文件预览地址
      title: '预览',
      // 按钮权限 --- 开始 ---
      addClueAuth: true,
      searchClueAuth: true,

      docTempAuthCh: false,
      docTempAuth: false,
      docManageAuthCh: false,
      docManageAuth: false,
      importDocAuth: false,
      deleteDocAuth: false,
      editDocAuth: false,

      docPatentAuthCh: true,
      docMarkAuthCh: false,
      docSoftAuthCh: false,
      docRuleAuthCh: false,
      docOtherAuthCh: false,
      // 线索权限按钮

      multipleSelection: [],

       // 搜索框开始
      drawer: false,
      direction: 'rtl',
      searchDateValue: '',
      // 搜索框结束

      // 列表数据
      docForm: {
        doc_id: '',
        doc_name: '',
        doc_type: '',
        doc_category: '',
        doc_url: '',
        doc_business: '',
        doc_desc: ''
      },
      projectForm: {
        id: '',
        project_name: '',
        customer_name: '',
        contacts: '',
        mobile: '',
        project_money: '',
        charge_type: '',
        type_value: '',
        status: '',
        desc: '',
      },
      importForm: {

      },
      formInline: {
        page: 1,
        ps: 15,
        search: '',
        cate: '专利文档',
        name: '',
        business: ''
      },
      businessArr: [],
      categroyArr: [],
      // 收费方式单位
      unit: '',
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel:webUrl + '/admin/doc/uploadDoc',
      userparm: [], //搜索权限
      listData: [], //用户数据
      projectData: [], //项目数据
      docData: [], //文档数据
       // 参数校验
      docFormRule: {
        doc_name:[{ required: true, message: '请输入文档名称', trigger: 'blur' }],
        doc_url:[{ required: true, message: '请上传文档', trigger: 'blur' }],
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 15,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.getdata(this.formInline)
    let btnAuth = JSON.parse(localStorage.getItem('btnAuth'))
    if(btnAuth.includes("importDocAuth")){
      this.importDocAuth = true
    }
    if(btnAuth.includes("deleteDocAuth")){
      this.deleteDocAuth = true
    }
    if(btnAuth.includes("editDocAuth")){
      this.editDocAuth = true
    }
    if(btnAuth.includes("docTempAuth")){
      this.docTempAuth = true
      this.docTempAuthCh = true
      this.getDocPageList()
    }
    if(btnAuth.includes("docManageAuth")){
      this.docManageAuth = true
      if(!this.docTempAuth){
        this.docManageAuthCh = true
    }}

    // this.getProjectPageList()
    // this.getDocPageList()
    this.getCate()
    this.getBusiness()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 视频上传oss 开始

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.docForm.doc_url = response.data.url
          // this.importFormVisible = false
          // this.getProjectPageList()
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
      //  if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
      //     that.$message({
      //         type: 'error',
      //         message: '上传文件只能为excel文件，且为xlsx,xls格式!'
      //     })
      //     return true
      //   }
      return true
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    // 视频上传oss 结束

    // 获取项目列表
    getProjectPageList() {
      this.loading = true
      getProject(this.formInline)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.projectData = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
        }else{
            this.$message({
              type: 'error',
              message: res.msg
            }) 
        }
      })
    },
    // 获取文档列表
    getDocPageList() {
      this.loading = true
      getDocList(this.formInline)
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
            this.docData = res.data.dataList
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.loading = false
            this.drawer = false
        }else{
            this.$message({
              type: 'error',
              message: res.msg
            }) 
        }
      })
    },
    // 控制是否显示编辑页面
    handleEdit(index, row) {
      if(row){
        this.title = '编辑文档'
        this.docForm.doc_id = row.id
        this.docForm.doc_name = row.doc_name
        this.docForm.doc_business = row.doc_business
        this.docForm.doc_category = row.doc_category
        this.docForm.doc_url = row.doc_url
        this.docForm.doc_desc = row.doc_desc
        this.docFormVisible = true
      }else{
        this.title = '添加文档'
        this.docForm.doc_id = ''
        this.docForm.doc_name = ''
        this.docForm.doc_business = ''
        this.docForm.doc_category = ''
        this.docForm.doc_url = ''
        this.docForm.doc_desc = ''
        this.docFormVisible = true
      }
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getDocPageList()
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    // 编辑项目
    editProject(projectForm) {
      this.$refs[projectForm].validate(valid => {
        if(valid){
          editProject(this.projectForm)
          .then(res=>{
            res = checkLogin(res)
            if(res.code == 200){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.projectFormVisible = false
              this.getProjectPageList()
            }else{
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
        }else{
          return false
        }
      })
    },
    // 编辑文档
    editDoc(docForm) {
    this.$refs[docForm].validate(valid => {
        if(valid){
          editDoc(this.docForm)
          .then(res=>{
            res = checkLogin(res)
            if(res.code == 200){
               this.$message({
                type: 'success',
                message: res.msg
              })
              this.docFormVisible = false
              this.getDocPageList()
            }else{
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
        }else{
          return false
        }
      })
    },
    // 删除文档
    delDoc(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          delDoc({doc_id: row.id})
            .then(res=>{
              res = checkLogin(res)
              if(res.code == 200){
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getDocPageList()
              }else{
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
        })
        .catch(() => {
          this.loading = false
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 查询文档分类
    getCate() {
      let sign = 'docCate'
      getDictCate({sign: sign})
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
          this.categroyArr = res.data
        }
      })
    },
    getBusiness() {
      let sign = 'businessSet'
      getDictCate({sign: sign})
      .then(res=>{
        res = checkLogin(res)
        if(res.code == 200){
          this.businessArr = res.data
        }
      })
    },
    // 查询所属公司

    // 预览文档
    previewDoc(index, row) {
      console.log(row)
      let url = row.doc_url
      let type = row.doc_type
      let authType = ['doc','pdf','docx',]
      if(!authType.includes(type)){
        this.$message({
          type: 'info',
          message: '该文档暂不支持预览'
        })
        return false
      }
      this.title = '文档预览'
      if(type == 'pdf'){
        // 直接预览
        this.viewPDFUrl = url
        this.viewPDFVisible = true
      }
    },
    // 下载文档
    loadDoc(index, row) {
      let docUrl = row.doc_url
      let docId = row.id
      // 加一个确认弹窗
      this.$confirm('确定下载吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        loadDoc({doc_id: docId})
        .then(res=>{
          res = checkLogin(res)
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
          window.location.href = docUrl
          this.getDocPageList()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
    },
    // 收费方式改变
    changeFeeType(type) {
      if(type == '比例收费'){
        this.unit = '%'
      }else if(type == "定额收费"){
        this.unit = '万元'
      }else if(type == '其他'){
        this.unit = ''
      }
    },
     matterStatus: function(obj) {
      if(obj.status == 1){
          return '是'
      }else if(obj.status == 2){
          return '否'
      }else{
          return '其他'
      }
    }, 
    // 删除项目
    delProject(index, row) {
      this.$confirm('确定要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        delProject({id: row.id})
          .then(res=>{
            res = checkLogin(res)
            if(res.code == 200){
              this.$message({
                type: 'success',
                message: res.msg
              })
              this.getProjectPageList()
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
      })
      .catch(() => {
        this.loading = false
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })

    },
    // 导出勾选中的数据 
    checkDownLoad() {
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
          this.$message({
            type: 'info',
            message: '未勾选任何记录'
          })
          return false;
      }
      this.$confirm('确定导出勾选的记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
      .then(()=>{
        const idStr = JSON.stringify(idsArr)
          downloadProject({ids: idStr})
          .then( res=> {
            res = checkLogin(res)
            if(res.code == 200){
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
              window.location.href = res.data.url
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
      })
      .catch(()=>{
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 显示导入页面是否显示
    handleImport() {
      this.title = '项目导入'
      this.importFormVisible = true
    },
    // 下载导入模板
    downloadImportExcel() {
      getImportProjectExcel()
      .then(res=>{
        if(res.code == 200){
          console.log(res)
          this.$message({
            type: 'success',
            message: '模板下载成功!'
          })
          window.location.href = res.data.url
        }else{
          this.$message({
            type: 'error',
            message: '模板下载失败!'
          })
        }
      })
    },
    clickLabel(label) {
      this.formInline.page = 1
      if(label == 'patent'){
        // this.getDocPageList()
        this.docPatentAuthCh = true;
        this.docMarkAuthCh = false;
        this.docSoftAuthCh = false;
        this.docRuleAuthCh = false;
        this.docOtherAuthCh = false;
        this.formInline.cate = '专利文档'
        this.getDocPageList()
      }else if(label == 'mark') {
        // this.getRoleData()
        this.docPatentAuthCh = false;
        this.docMarkAuthCh = true;
        this.docSoftAuthCh = false;
        this.docRuleAuthCh = false;
        this.docOtherAuthCh = false;
        this.formInline.cate = '商标文档'
        this.getDocPageList()
      }else if(label == 'soft'){
        this.docPatentAuthCh = false;
        this.docMarkAuthCh = false;
        this.docSoftAuthCh = true;
        this.docRuleAuthCh = false;
        this.docOtherAuthCh = false;
        this.formInline.cate = '版权文档'
        this.getDocPageList()
      }else if(label == 'rule'){
        this.docPatentAuthCh = false;
        this.docMarkAuthCh = false;
        this.docSoftAuthCh = false;
        this.docRuleAuthCh = true;
        this.docOtherAuthCh = false;
        this.formInline.cate = '商务规则'
        this.getDocPageList()
      }else{
        this.docPatentAuthCh = false;
        this.docMarkAuthCh = false;
        this.docSoftAuthCh = false;
        this.docRuleAuthCh = false;
        this.docOtherAuthCh = true;
        this.formInline.cate = '其他文档'
        this.getDocPageList()
      }
    },
    // 刷新数据
    refreshData() {
      // this.formInline.page = 1
      
      this.getDocPageList()
    },
    // 模糊查询(搜索框)
    searchDoc() {
      this.getDocPageList()
    },
    // 重置查询条件
    resetSearch() {
      this.formInline.page = 1
      this.formInline.ps = 15
      this.formInline.search = ''
      this.formInline.name = ''
      // this.formInline.cate = ''
      this.formInline.business = ''
      this.getDocPageList()
    },
    // 开启搜索框
    handleDrawerOpen() {
      this.drawer = true
    },
    // 关闭搜索框
    handleDrawerClose() {
      this.drawer = false
    },
    // 文档删除(勾选数据)
    delDocCheck() {
      let checks = this.multipleSelection;
      if(checks.length <= 0){
        this.$message({
          type: 'warning',
          message: '暂无勾选数据!'
        })
        return false
      }
      this.$confirm('确定删除勾选中的数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        let idArr = []
        checks.forEach(function(item,index){
          idArr.push(item.id)
        })
        let ids = JSON.stringify(idArr)
        delCheckDoc({ids: ids})
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            // 删除成功,刷新数据
            this.getDocPageList()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 关闭编辑、增加弹出框0
    closeDialog(formName) {
      if(formName == 'projectForm'){
        this.projectFormVisible = false
      }else if(formName == 'docForm'){
        this.docFormVisible = false
      }
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.clue-btn {
  background-color: #333333;
  color: #FFFFFF;
}
.clue-search {
  margin-left: 20px;
  background-color: #E4E4E4;
}
.clue-search-btn {
  background-color: #333333 !important;
  color: #FFFFFF !important;
  font-weight: 700 !important;
  border-top-left-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.u-btn {
  display: none;
}
.mouse {
  cursor: pointer;
  color: #D9D9D9;
  margin-right: 18px;
}
.selected {
  color: #333333;
}
.feeType>>>.el-form-item__content{
  display: flex !important;
}
.rightDrawer {
  width: 40px;
  height: 100px;
  background-color: #00C8DF;
  position: absolute;
  border-radius: 10px 0px 0px 10px;
  left: auto;
  right: 0;
  top: 40%;
  z-index: 10;
  color: #FFFFFF;
  text-align: center;
  margin-top: auto;
  line-height: 100px;
  cursor: pointer;
}
.searchDrawer {
  height: 80vh;
  margin-top: auto;
  margin-bottom: auto;
  border-radius: 20px 0px 0px 20px;
}
.searchDrawer>>>.el-form-item {
  margin-bottom: 10px;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/crm/doc.vue